import { getAdminPasswordValidationError } from "@shared/admin-password-policy";

export function validateAdminPasswordForm(
  newPassword: string,
  confirmPassword: string,
): string | null {
  const passwordError = getAdminPasswordValidationError(newPassword);
  if (passwordError) return passwordError;
  if (newPassword !== confirmPassword) return "两次输入的新密码不一致";
  return null;
}
